export const supportsPassive = false

export function on(target, event, handler, passive = false) {
  target.addEventListener(event, handler, supportsPassive ? { capture: false, passive } : false)
}

export function off(target, event, handler) {
  target.removeEventListener(event, handler)
}

export function stopPropagation(event) {
  event.stopPropagation()
}

export function preventDefault(event, isStopPropagation) {
  /* istanbul ignore else */
  if (typeof event.cancelable !== "boolean" || event.cancelable) {
    event.preventDefault()
  }

  if (isStopPropagation) {
    stopPropagation(event)
  }
}
